import React from "react";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import GateLogRow, {
  DeniedIcon,
  DriveInIcon,
  DriveOutIcon,
  GrantedIcon,
} from "../GateLogRow";
import Legend from "../Legend";
import LegendItem from "../Legend/LegendItem";
import SimplePagination from "../SimplePagination";
import Table from "../Tables/Table";

const columns = [
  { value: "direction", name: "Durchfahrt" },
  { value: "card_holder", name: "Gast" },
  { value: "created_at", name: "Zeit" },
  { value: "nfc_card_uid", name: "NFC Karte" },
];

const GateLogTable = ({ gateLogs, onPageClick }) => {
  return (
    <>
      <div className="ui-table-container mb-3">
        <Table
          columns={columns}
          empty={gateLogs?.entries?.length === 0}
          emptyMessage="Keine Durchfahrten vorhanden"
          id="dataTable"
          width="100%"
          cellSpacing="0"
        >
          {gateLogs?.entries?.map((gateLog) => (
            <GateLogRow key={gateLog.id} gateLog={gateLog} />
          ))}
        </Table>
        {onPageClick && (
          <SimplePagination
            pagination={gateLogs?.pagination}
            onClick={onPageClick}
          />
        )}
      </div>
      <Legend>
        <LegendItem
          icon={faInfoCircle}
          text={<b>Erklärung:</b>}
          classNames="font-weight-bold"
        />
        <LegendItem
          icon={DriveInIcon}
          text="Einfahrt"
          classNames="text-success"
        />
        <LegendItem
          icon={DriveOutIcon}
          text="Ausfahrt"
          classNames="text-danger"
        />
        <LegendItem
          icon={GrantedIcon}
          text="Gültiger Zugriff"
          classNames="text-success"
        />
        <LegendItem
          icon={DeniedIcon}
          text="Ungültiger Zugriff"
          classNames="text-danger"
        />
      </Legend>
    </>
  );
};

export default GateLogTable;
